import { ExclamationTriangleIcon, XMarkIcon } from '@heroicons/react/24/outline';
import cn from 'classnames';

import SalonModal from 'components/dialog/SalonModal.component';
import Button from 'components/form/Button.component';
import IconStatus from 'components/generic/IconStatus.component';
import useIsMobileViewport from 'hooks/useIsMobileViewport.hook';
import { useTranslation } from 'providers/GILT.provider';
import { useTheme } from 'providers/Theme.provider';

import CN from './ExitWithoutSavingModal.module.scss';

export const ExitWithoutSavingModal = ({ isOpen, onClose, onSaveAsDraft, onContinueToExit, formName }) => {
  const { t } = useTranslation();
  const { isDarkMode } = useTheme();
  const isMobile = useIsMobileViewport();

  const displayName = formName || t('consultationForms.exitWithoutSavingModal.untitled');

  return (
    <SalonModal
      tag="ExitWithoutSavingModal"
      isOpen={isOpen}
      shouldCloseOnOverlayClick
      shouldCloseOnEsc
      onClose={onClose}
      fullWidth={!isMobile}
      mode="dark"
      customClass={cn(CN.modalDialog, { [CN.darkMode]: isDarkMode })}
    >
      <SalonModal.Header>
        <div data-bem="ExitWithoutSavingModal__header" className={cn(CN.modalHeader, { [CN.darkMode]: isDarkMode })}>
          <Button variant="icon" tag="ExitWithoutSavingModal__close" data-testid="ExitWithoutSavingModal__close" className={CN.closeButton} onClick={onClose}>
            <XMarkIcon className={CN.closeIcon} />
          </Button>
        </div>
      </SalonModal.Header>
      <SalonModal.Body>
        <IconStatus variant="alert" width="lg">
          <ExclamationTriangleIcon className={CN.alertIcon} />
        </IconStatus>
        <div className={cn(CN.heading, { [CN.darkMode]: isDarkMode })}>
          <h2 className={CN.title}>{t('consultationForms.exitWithoutSavingModal.title')}</h2>
          <p className={CN.message}>
            {t('consultationForms.exitWithoutSavingModal.messagePrefix')} <strong>&lsquo;{displayName}&rsquo;</strong> {t('consultationForms.exitWithoutSavingModal.messageSuffix')}
          </p>
        </div>
      </SalonModal.Body>
      <SalonModal.Footer>
        <Button variant="tertiary" onClick={onSaveAsDraft} tag="ExitWithoutSavingModal__saveDraft">
          {t('consultationForms.exitWithoutSavingModal.saveAsDraft')}
        </Button>
        <Button variant="primaryForce" onClick={onContinueToExit} tag="ExitWithoutSavingModal__exit">
          {t('consultationForms.exitWithoutSavingModal.continueToExit')}
        </Button>
      </SalonModal.Footer>
    </SalonModal>
  );
};
